import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-vercel', 'IconBrandVercel', [
  ['path', { d: 'M3 19h18l-9 -15z', key: 'svg-0' }],
]);
